module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-mt-more-list container-fluid col-xs-12"
  }, [_c('div', {
    staticClass: "title text-center"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "container"
  }, [_vm._v(_vm._s(_vm.subtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "more-list container"
  }, [_c('ul', _vm._l((_vm.moreList), function(index) {
    return _c('li', [_c('a', {
      attrs: {
        "href": index.elements.url.value
      }
    }, [_vm._v("\t" + _vm._s(index.elements.header_title.value) + " ")])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-725b9f64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/more-list.vue
// module id = 1539
// module chunks = 0